import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The hover controls of a zero (canvas) block. The same shape as the ordinary
 * block's, minus the entries a canvas never offers: nothing inside it can lock
 * copying or deleting the way the cart widget and the product limit do, and
 * "copy to page" was bound but never switched on, so it is not here.
 */
@Component({
    selector: 'web-zero-block-controls',
    templateUrl: './zero-block-controls.component.html',
    styleUrls: ['./zero-block-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TooltipModule, TranslateModule],
})
export class ZeroBlockControlsComponent {
    /** Reordering stops at the ends of the page and at a pinned or shared neighbour. */
    public readonly disableMoveUp = input<boolean>(false);
    public readonly disableMoveDown = input<boolean>(false);

    public readonly selectActionTooltip = input<string>('');

    /** Pinned to the top or the bottom of the viewport — see {@link isPinned}. */
    public readonly pinOnTheTop = input<boolean>(false);
    public readonly pinOnTheBottom = input<boolean>(false);

    public readonly saveBlockToGallery = input<boolean>(false);

    public readonly selectEvent = output<void>();
    public readonly copyEvent = output<void>();
    public readonly saveBlockToGalleryEvent = output<void>();
    public readonly deleteEvent = output<void>();
    public readonly moveUpEvent = output<void>();
    public readonly moveDownEvent = output<void>();
    public readonly toggleMoreActionState = output<boolean>();

    /**
     * A pinned block sits at a fixed end of the page, so it cannot be reordered:
     * the arrows stay on screen, disabled, with a tooltip saying why.
     */
    public readonly isPinned = computed<boolean>(() => this.pinOnTheTop() || this.pinOnTheBottom());

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public copyAction(): void {
        this.copyEvent.emit();
    }

    public saveBlockToLibraryAction(): void {
        this.saveBlockToGalleryEvent.emit();
    }

    public deleteAction(): void {
        this.deleteEvent.emit();
    }

    public moveUpAction(): void {
        if (this.disableMoveUp() || this.isPinned()) {
            return;
        }

        this.moveUpEvent.emit();
    }

    public moveDownAction(): void {
        if (this.disableMoveDown() || this.isPinned()) {
            return;
        }

        this.moveDownEvent.emit();
    }

    public isShowDropDownMenu(state: boolean): void {
        this.toggleMoreActionState.emit(state);
    }
}
